import { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from './entry.module.less';
import SkeletonMapDetail from '@/common/components/Skeleton/SkeletonMapDetail';
import V2Container from '@/common/components/Data/V2Container';
import Top from '../index/components/AreaDetailDrawer/components/Top';
import Main from '../index/components/AreaDetailDrawer/components/Main';
import { useMethods } from '@lhb/hook';
import { spotEvaluationDetailShare, spotEvaluationOverviewShare } from '@/common/api/spotevaluation';
import { urlParams } from '@lhb/func';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { getShareContent } from '@/common/api/common';
import { SpotTypeEnum } from '../index/ts-config';
const ShareSpotEvaluation: FC<any> = () => {
  const { shareId } = urlParams(location.search) || {};
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    lng: '',
    lat: '',
    cityId: '',
    cityName: '',
    poiName: '',
    type: '',
    modelClusterId: '',
    modelConfigId: ''
  }); // 模拟弹窗需要的传参，不再对组件内进行其他定制化
  const openTimeRef: any = useRef<any>(0);
  const [detail, setDetail] = useState<any>({}); // 详情信息
  const [overViewData, setOverViewData] = useState<any>({}); // 概览卡片
  const [loading, setLoading] = useState<boolean>(false); // 加载中
  const [isLoaded, setLoaded] = useState(false); // 详情是否加载完成
  const [configSwitch, setConfigSwitch] = useState<any>({});
  const [shareParams, setShareParams] = useState<any>({});
  useEffect(() => {
    if (drawerData.lng && drawerData.lat) {
      // methods.eventTracking();
      methods.getDetail();
    }
  }, [drawerData]);

  useEffect(() => {
    if (shareId) {
      methods.getShareContent();
    } else {
      V2Message.warning('当前分享链接已失效');
    }
  }, [shareId]);

  // 是否是商场类型
  const isMallType = useMemo(() => {
    const { resourceMallFlag } = detail || {};
    return !!resourceMallFlag;
  }, [detail]);

  // methods
  const methods = useMethods({
    getShareContent() {
      getShareContent({ id: shareId }).then((res) => {
        const content = JSON.parse(res.content || '{}');
        const { configSwitch: config, globalAliasItemVOs } = content || {};
        setShareParams({ globalAliasItemVOs });
        config && Object.keys(config).length && setConfigSwitch(config);
        setDrawerData({
          ...content,
          type: content.type || 1, // 未定义时默认为街边店，兼容历史已经分享的
          open: true,
        });
      });
    },
    getDetail: async () => { // 获取商圈详情
      setLoading(true);
      // const detailParams = {
      //   lng: drawerData.lng,
      //   lat: drawerData.lat,
      //   tenantId: drawerData.tenantId,
      //   poiName: drawerData.poiName,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId
      // };
      const { lng, lat, poiName, type, modelClusterId, modelConfigId, radius, tenantId } = drawerData;
      const params: any = {
        type,
        modelConfigId,
        tenantId,
      };
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
      }
      if (type === SpotTypeEnum.Street) {
        params.lng = lng;
        params.lat = lat;
        params.radius = radius;
      }
      if (poiName) {
        params.poiName = poiName;
      }
      Promise.all([
        spotEvaluationDetailShare(params),
        spotEvaluationOverviewShare(params),
      ])
        .then(([detailRes, overviewRes]) => {
          setDetail(detailRes);
          setOverViewData(overviewRes);
        })
        .catch((error) => {
          console.error('Error fetching details:', error);
        })
        .finally(() => {
          setLoading(false);
          setLoaded(true);
        });
    },
    // 当前为选址地图埋点，需替换
    eventTracking: (isOpen = true) => { // 埋点
      if (isOpen) {
        openTimeRef.current = new Date().getTime();
        return;
      }
      // 关闭的时候上报总时长
      const curTimestamp = new Date().getTime();
      const timeLag = curTimestamp - openTimeRef.current; // 停留时长
      if (openTimeRef.current && curTimestamp && timeLag > 0) {
        window.LHBbigdata.send({
          event_id: 'dcf71805-ed9e-a3e9-1c09-85daf0d49e02', // 事件id
          msg: {
            viewTimestamp: timeLag
          }
        });
        openTimeRef.current = 0;
      }
    },
  });

  return (
    <div className={styles.container}>
      {(loading || !isLoaded)
        ? <SkeletonMapDetail/>
        : <V2Container
          // 容器上下padding 0， 所以减去就是0
          style={{ height: '100vh' }}
          extraContent={{
            top: <Top
              detail={detail}
              drawerData={drawerData}
              tenantId={drawerData.tenantId}
            />,
          }}
        >
          <Main
            viewChanceDetail={false}
            drawerData={drawerData}
            detail={detail}
            overViewData={overViewData}
            isMallType={isMallType}
            showChancePoint={false}
            tenantId={drawerData.tenantId}
            configSwitch={configSwitch}
            shareParams={shareParams}
          />
        </V2Container>
      }
    </div>
  );
};

export default ShareSpotEvaluation;
